import { Box, Grid } from '@mui/material';
import CustomField from '../../../../../../components/CustomFormsComponents/CustomField';
import ButtonActions from '../../../../../../components/ButtonActions';

const DosimetryForm = ({
    selectedCarcinogenicReportId,
    selectedEquipment,
    isEditing,
    handleCloseDrawer,
    dosimetryForm,
    handleSubmit,
    handleCancelClick,
    onlyVisual

}: any) => {
    const { formData, dosimetryFieldsConfig, errors, handleChange, translate } = dosimetryForm;

    return (
        <Box
            display="flex"
            flexDirection={'column'}
            justifyContent="space-between"
            sx={{ flexDirection: 'column', height: '100%', minHeight: '100%' }}
        >
            <Grid mt={2} container spacing={2} rowSpacing={0.01}>
                {dosimetryFieldsConfig.map((field: any, index: number) => (
                    <Grid
                        item
                        xs={field?.gridSpace?.xs}
                        sm={field?.gridSpace?.sm}
                        md={field?.gridSpace?.md}
                        lg={field?.gridSpace?.lg}
                        key={index}
                    >
                        <CustomField
                            config={field}
                            value={formData[field.name as keyof any]}
                            onChange={handleChange}
                            onlyVisual={onlyVisual}
                            error={errors[field.name as string]?.hasError}
                            helperText={
                                errors[field.name as string]?.errorMessage || field.helperText
                            }
                        />
                    </Grid>
                ))}
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ marginTop: '1rem' }}
            >
                <Box
                    sx={{
                        '& > :not(style)': { m: 0 },
                        display: 'flex'
                    }}
                >
                    {!onlyVisual && (
                        <ButtonActions
                            handleClose={handleCancelClick}
                            renderBackAction
                            returnText={translate('radiologicalEquipmentForm.buttons.cancel')}
                            confirmText={translate('radiologicalEquipmentForm.buttons.next')}
                            loading={false}
                            disabled={false}
                            onClick={handleSubmit}
                            borderRadius="4px"
                            size="small"
                        />
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default DosimetryForm;
